import ReactDOM from 'react-dom'
import { Injectable, Inject } from '../serviceLocator'
import E from 'web-panel-essentials/misc'

@Injectable('layout', true)
class Layout {
  @Inject 'logger'

  renderView (view, targetRegionId) {
    if (!targetRegionId) throw E('T_REGREQ', 'Target region required')
    const element = (id) => document.getElementById(id)

    this.logger.info('Rendering', targetRegionId)
    return ReactDOM.render(view, element(targetRegionId))
  }
}

export default Layout
